'use strict';

/* Views */
import DocumentEdit from './edit/document-edit.component';
import DocumentList from './list/document-list.component';
import DocumentUpload from './upload/document-upload.component';
import DocumentTree from './tree/document-tree.component';
import DocumentTreeEdit from './tree-edit/document-tree-edit.component';
import DocumentTreeUpload from './tree-upload/document-tree-upload.component';
import DocumentTreeAddFromArchive from './tree-add-from-archive/document-tree-add-from-archive.component';

/* Services */
import DocumentService from '../../services/document/document.service';

export default angular.module('conduuApp.documents', [DocumentUpload, DocumentEdit, DocumentList, DocumentTreeUpload, DocumentTreeAddFromArchive,
  DocumentTree, DocumentTreeEdit, DocumentService])
  .name;



// WEBPACK FOOTER //
// ./client/app/document/index.js